import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useEditBlockForm} from '../../model';

interface EditBlockModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  blockId: string | null;
}

export const EditBlockModal = ({open, setOpen, blockId}: EditBlockModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditBlockForm({setOpen, blockId});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Блок',
    title: 'Ошибка при редактировании блока',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактировать блок'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Заголовок блока"
          placeholder="Заголовок блока"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title}
        />
        <FormInput
          label="Название блока"
          placeholder="Название блока"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.name && errors.name}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
